import React from 'react';

import type { Announcement } from '../../types/index';
import AnnouncementList from '../AnnouncementList/AnnouncementList';
import ContactUs from '../ContactUs/ContactUs';
import Search from '../Search/Search';

import styles from './HelpContainer.scss';

interface Props {
  announcements: Announcement[];
  showTitle?: boolean;
  children?: React.ReactNode;
}

const HelpContainer: React.FC<Props> = ({ children, announcements, showTitle = false }) => (
  <div className={styles.content}>
    <Search showTitle={showTitle} />
    <AnnouncementList announcements={announcements} />
    {children}
    <ContactUs />
  </div>
);

export default HelpContainer;
